exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sider-bar{position:fixed;width:15.625rem;top:3.625rem;bottom:0;z-index:555;background-color:#fff;box-shadow:2px 2px 4px rgba(0,0,0,.15)}.sider-bar,.sider-bar ul{height:100%}.sider-bar ul li{font-size:.875rem}.sider-bar ul li a{display:block;padding:1.28em 1em;height:4.14em;color:#444;text-decoration:none;-webkit-transition:background-color .2s ease-out;transition:background-color .2s ease-out}.sider-bar ul li a:hover{background-color:rgba(0,0,0,.1)}.sider-bar ul li a i{margin-right:.72em;color:#444}.slide-fade-enter-active,.slide-fade-leave-active{-webkit-transition:all .2s ease-out;transition:all .2s ease-out}.slide-fade-enter,.slide-fade-leave-to{-webkit-transform:translateX(-250px);transform:translateX(-250px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-28fe3a04","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation.vue
// module id = 23
// module chunks = 0